<mvs-crud-page [objectStructureRequest]="objectBrowserRequest"
               [defaultLabel]="defaultLabel">
</mvs-crud-page>


<mvs-widget *ngIf="widgetCustomerCategoryType" [widgetData]="widgetCustomerCategoryType"></mvs-widget>

<p-button (click)="batchUpdateNames()" title="Namen aktualisieren" [disabled]="batchBusy">Namen aktualisieren</p-button>
<p-progressSpinner ariaLabel="Processing" *ngIf="batchBusy" />
